import { DayView, WeekView, AgendaView, MonthView, YearView } from "./views";
export const registeredViews = {
    day: new DayView(),
    week: new WeekView(),
    month: new MonthView(),
    year: new YearView(),
    agenda: new AgendaView(),
};
//# sourceMappingURL=registeredViews.js.map